<template>
  <div class="max-w-[400px]" v-if="messageData && messageData?.timeout && messageData?.text">
    <div class="flex items-center justify-center" v-if="messageData.timeout > 10">
      <SimpleTimer :time-limit="messageData.timeout"/>
    </div>
    <div class="font-normal text-black text-center text-base leading-5 mt-2">{{ messageData.text }}</div>
  </div>
</template>

<script>

import SimpleTimer from "@/components/ui/SimpleTimer.vue";

export default {
  name: "JenkinsNotification",
  props: {
    messageData: {
      type: Object,
      default: () => {}
    }
  },
  components: {SimpleTimer}
}
</script>